import _ from 'lodash';
import * as userApi from '../../api/userApi';
import { LOGOUT_SUCCESS } from './auth';

const GET_USER = 'efes/user/GET_USER';
const GET_USER_SUCCESS = 'efes/user/GET_USER_SUCCESS';
const GET_USER_FAIL = 'efes/user/GET_USER_FAIL';

const GET_EKENG_USER = 'efes/user/GET_EKENG_USER';
const GET_EKENG_USER_SUCCESS = 'efes/user/GET_EKENG_USER_SUCCESS';
const GET_EKENG_USER_FAIL = 'efes/user/GET_EKENG_USER_FAIL';
const CLEAR_EKENG_USER = 'efes/user/CLEAR_EKENG_USER';

const UPDATE_USER = 'efes/user/UPDATE_USER';
const UPDATE_USER_SUCCESS = 'efes/user/UPDATE_USER_SUCCESS';
const UPDATE_USER_FAIL = 'efes/user/UPDATE_USER_FAIL';

const CHANGE_USER_PASS = 'efes/user/CHANGE_USER_PASS';
export const CHANGE_USER_PASS_SUCCESS = 'efes/user/CHANGE_USER_PASS_SUCCESS';
export const CHANGE_USER_PASS_FAIL = 'efes/user/CHANGE_USER_PASS_FAIL';

const initialState = {
  user: {},
  ekengUser: {},
  loadingUser: false,
  loadingEkengUser: false,
  getUserError: null,
  updateUserError: null,
  updatingPass: false,
  updatePassError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        loadingUser: true,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        user: {
          ...action.result,
          isAdmin: !!_.find(action.result.roles, (o) => o.name === 'admin'),
          isAccountant: !!_.find(action.result.roles, (o) => o.name === 'accountant'),
        },
      };
    case GET_USER_FAIL:
      return {
        ...state,
        loadingUser: false,
        getUserError: action.error,
      };
    case GET_EKENG_USER:
      return {
        ...state,
        loadingEkengUser: true,
      };
    case GET_EKENG_USER_SUCCESS:
      return {
        ...state,
        loadingEkengUser: false,
        ekengUser: action.result,
      };
    case GET_EKENG_USER_FAIL:
      return {
        ...state,
        ekengUser: { ...initialState.ekengUser },
        loadingEkengUser: false,
        getEkengUserError: action.error,
      };
    case CLEAR_EKENG_USER:
      return {
        ...state,
        ekengUser: { ...initialState.ekengUser },
        loadingEkengUser: false,
      };
    case UPDATE_USER:
      return {
        ...state,
        loadingUser: true,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        user: action.result,
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        loadingUser: false,
        updateUserError: action.error,
      };
    case CHANGE_USER_PASS:
      return {
        ...state,
        updatingPass: true,
        updatePassError: null,
      };
    case CHANGE_USER_PASS_SUCCESS:
      return {
        ...state,
        updatingPass: false,
        updatePassError: null,
      };
    case CHANGE_USER_PASS_FAIL:
      return {
        ...state,
        updatingPass: false,
        updatePassError: action.error.response.data,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

export function getUser() {
  return {
    actions: [
      { type: GET_USER },
      { type: GET_USER_SUCCESS },
      { type: GET_USER_FAIL },
    ],
    promise: userApi.getUser(),
  };
}

export function updateUser(data, userId) {
  return {
    actions: [
      { type: UPDATE_USER },
      { type: UPDATE_USER_SUCCESS },
      { type: UPDATE_USER_FAIL, showError: true },
    ],
    promise: userApi.updateUser(data, userId),
  };
}

export function getUserFromEkeng(data) {
  return {
    actions: [
      { type: GET_EKENG_USER },
      { type: GET_EKENG_USER_SUCCESS },
      { type: GET_EKENG_USER_FAIL },
    ],
    promise: userApi.getUserFromEkeng(data),
  };
}

export function clearEkengUser() {
  return {
    type: CLEAR_EKENG_USER,
  };
}

export function changePassword(passwords, userId) {
  return {
    actions: [
      { type: CHANGE_USER_PASS },
      { type: CHANGE_USER_PASS_SUCCESS, showSuccess: true },
      {
        type: CHANGE_USER_PASS_FAIL,
        showError: true,
        customMsg: null,
      },
    ],
    promise: userApi.updateUserPass(passwords, userId),
  };
}
